import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { selectUiDrawerClientTop } from '../../../store/ui/ui.selectors'
import { isGE } from '../../Device'
import { MINI_MAP_HEIGHT } from '../../main/main.constants'
import { PREHEADER_HEIGHT } from '../../header/header-constants'

// all of the following value are in px
const GEOLOC_BUTTON_HEIGHT = 40
const LAYER_BUTTON_HEIGHT = 48
const BOTTOM_MARGIN = 24
const DRAWER_TOP_POSITION = MINI_MAP_HEIGHT + PREHEADER_HEIGHT
const MAX_GEOLOC_BUTTON_TOP_POSITION =
  DRAWER_TOP_POSITION - LAYER_BUTTON_HEIGHT - GEOLOC_BUTTON_HEIGHT - BOTTOM_MARGIN * 2
const MAX_LAYER_BUTTON_TOP_POSITION = DRAWER_TOP_POSITION - LAYER_BUTTON_HEIGHT - BOTTOM_MARGIN

export const GEOLOC_BUTTON_TYPE = 'geoloc'
export const LAYERS_BUTTON_TYPE = 'layers'

const useDynamicButtons = ({ buttonType }) => {
  const currentDrawerTopPosition = useSelector(selectUiDrawerClientTop)

  const getButtonStyle = useCallback(() => {
    if (isGE() || currentDrawerTopPosition === undefined) return undefined

    const commonStyle = {
      bottom: 'unset',
      transition: 'top 0.25s ease'
    }

    if (buttonType === GEOLOC_BUTTON_TYPE) {
      const calc = currentDrawerTopPosition - LAYER_BUTTON_HEIGHT - GEOLOC_BUTTON_HEIGHT - BOTTOM_MARGIN * 2
      return { ...commonStyle, top: calc > MAX_GEOLOC_BUTTON_TOP_POSITION ? calc : MAX_GEOLOC_BUTTON_TOP_POSITION }
    }

    if (buttonType === LAYERS_BUTTON_TYPE) {
      const calc = currentDrawerTopPosition - LAYER_BUTTON_HEIGHT - BOTTOM_MARGIN
      return { ...commonStyle, top: calc > MAX_LAYER_BUTTON_TOP_POSITION ? calc : MAX_LAYER_BUTTON_TOP_POSITION }
    }

    return undefined
  }, [currentDrawerTopPosition])

  return {
    getButtonStyle
  }
}

export default useDynamicButtons
